import type { ReadonlyURLSearchParams } from 'next/navigation';

export const createQueryString = (
  name: string,
  value: string,
  searchParams: ReadonlyURLSearchParams | URLSearchParams
) => {
  const params = new URLSearchParams(searchParams);
  params.set(name, value);

  return params.toString();
};

export const createQueryStringWithMultipleValues = (
  newParams: Record<string, string>,
  searchParams: ReadonlyURLSearchParams
) => {
  const params = new URLSearchParams(searchParams);

  for (const [name, value] of Object.entries(newParams)) {
    params.set(name, value);
  }

  return params.toString();
};
